import i18n from 'src/i18n';
export let homePageConstants = {
  heading: {
    desktopHeading: {
      firstHeadingLine1: i18n.t('firstHeadingLine'),
     },
    mobileHeading: {
      heading: "Virtual training on",
      paragraph: "Train with Experts in GE Healthcare or within your healthcare system.",
    },
    gradientText: i18n.t('gradientText'),
  },
  belowVideoData: {
    belowLineText: i18n.t('belowLineText'),
    headingFirstPart: i18n.t('headingFirstPart'),
    headingMidPart: " "+i18n.t('headingMidPart'),
    headingLastPart: " "+i18n.t('headingLastPart'),
    headingLastWord: " "+i18n.t('headingLastWord'),
    introPara: i18n.t('introPara'),
    questionText: i18n.t('questionText'),
    learnMoreBtnText: i18n.t('learnMoreBtnText'),
  }
};

i18n.on('languageChanged', function() {
  updateTranslations();
});

function updateTranslations () {
  homePageConstants = {
    heading: {
      desktopHeading: {
        firstHeadingLine1: i18n.t('firstHeadingLine'),
       },
      mobileHeading: {
        heading: "Virtual training on",
        paragraph: "Train with Experts in GE Healthcare or within your healthcare system.",
      },
      gradientText: i18n.t('gradientText'),
    },
    belowVideoData: {
      belowLineText: i18n.t('belowLineText'),
      headingFirstPart: i18n.t('headingFirstPart'),
      headingMidPart: " "+i18n.t('headingMidPart'),
      headingLastPart: " "+i18n.t('headingLastPart'),
      headingLastWord: " "+i18n.t('headingLastWord'),
      introPara: i18n.t('introPara'),
      questionText: i18n.t('questionText'),
      learnMoreBtnText: i18n.t('learnMoreBtnText'),
    }
  };
}


